import React, {useState} from "react";
import { Container } from "react-bootstrap";
import data from "../../data/data.json";
import HomeCard from "../../components/HomeCard/HomeCard";
import "./home.css"

const Home = () => {
  const [visible, setVisible] = useState(25);
  const interviewLinks = data.homeInterviews;

  return (
    <main className="pt-78">
      <Container>
        <div className="home">
          {interviewLinks.slice(0, visible).map((card) => (
            <article key={card.id}>
              <HomeCard path={card.btnUrl} title={card.title} />
            </article>
          ))}
        </div>
        {visible < interviewLinks.length && (
          <div className="d-flex justify-content-center mb-3">
            <button className="btn-load bg-black text-white py-2 px-3 rounded-4" onClick={() => setVisible((v) => v + 5)}>Load more</button>
          </div>
        )}

      </Container>
    </main>
  );
};

export default Home;
